export default "__VITE_ASSET__BsisV$p6__"